<template>
    <div class="context-menu"
         v-show="show"
         :style="style"
         ref="context"
         tabindex="0"
         @blur="close">

        <!-- Show project notes modal-->
        <button class="button is-warning"
                id="project-notes"
                @mousedown="projectNotesModal">Projektnoter</button>
        <hr />

        <div class="block">
            <p style="display:flex; flex-direction:row; margin-bottom: 1em;">
                <b-icon icon="calendar-edit"
                        custom-class="mdi-calendar-edit"
                        size="is-medium" />
                <span style="font-size: large; margin-left: 1em;">
                    {{ lastActionDays }}&nbsp;days</span>
            </p>

            <p style="display:flex; flex-direction:row; margin-bottom: 1em;">
                <b-icon icon="calendar-star"
                        custom-class="mdi-calendar-star"
                        size="is-medium" />
                <span style="font-size: large; margin-left: 1em;">
                    {{ creationDays }}&nbsp;days</span>
            </p>
            <p style="display:flex; flex-direction:row; ">
                <b-icon icon="map-marker-path"
                        custom-class="mdi-map-marker-path"
                        size="is-medium" /> <span style="font-size: large; margin-left: 1em;">
                    {{ $t(`projects.status.${currentStatus}`) }}</span>
            </p>
        </div>
        <button class="button is-danger"
                :disabled="lastActionDays < 1 || !projectIsOpen(currentStatus)"
                @mousedown="closeProject">Close project</button>
    </div>
</template>
<script>
import Vue from 'vue';

import ProjectNotesModal from './ProjectNotesModal.vue';

export default {
    name: 'ProjectContextMenu',
    components: {
    },
    props: {
        display: Boolean, // prop detect if we should show context menu
        lastActionDays: Number, // prop to detect if we should disable close project button
        creationDays: Number, // prop to detect if we should disable close project button
        currentStatus: String, // prop to detect if we should disable close project button
    },
    data() {
        return {
            left: 0, // left position
            top: 0, // top position
            show: false, // affect display of context menu
        };
    },
    computed: {
        // get position of context menu
        style() {
            return {
                top: `${this.top}px`,
                left: `${this.left}px`,
            };
        },
    },
    methods: {
        projectIsOpen(status) {
        // if project status is found in array return true otherwise return false
            return [
                'project-created',
                'project-clarification',
                'project-accepted',
                'project-offer-posted',
                'project-offer-accepted'
            ].includes(status);
        },
        // closes context menu 
        close() {
            this.show = false;
            this.left = 0;
            this.top = 0;
        },
        open(evt) {
            // Since we are only listening to right click event on first column, we can use eith pageX or clientX.
            // If we choose to listen on whole row, we should use pageX to get position of mouse relative to document

            // updates position of context menu 
            this.left = evt.pageX || evt.clientX;
            this.top = evt.clientY;

            // make element focused 
            // @ts-ignore
            Vue.nextTick(() => {
                this.$el.focus();
            });

            this.show = true;
        },
        closeProject() {
            // mousedown event is fired before blur event
            // click event does not fire if we click on button
            this.$emit('closeproject');
        },
        projectNotesModal() {
            // Close this window
            this.close();

            this.$emit('showprojectnotes');
        }
    },
};
</script>

<style scoped>
.context-menu {
    position: fixed;
    background: white;
    z-index: 999;
    cursor: pointer;

    display: flex;
    flex-direction: column;
    background-color: white;
    border: 1px solid #ccc;
    padding: 1rem;
    border-radius: 0.5rem;

}

#project-notes {
    margin: 0.5em, 0, 1em;
}
</style>



// WEBPACK FOOTER //
// src/taskflex/administration/components/projects/ProjectContextMenu.vue